export default __webpack_public_path__ + "static/madeinuk-logo-ff3eb6ddb10a928eb7cc7aba4439a2f0.svg";